import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { vacancyApi } from '@cp/entities/vacancy';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NEED_HELP_TIMING_MODAL_NAME } from 'src/app/shared/components/modals/needHelpTiming/const';
import { UXSlice, needHelpShownForGuestSelector, needHelpShownForRegisteredUserSelector } from 'src/shared/ux';
import { useIsAnyModalOpen, useModal } from 'src/shared/modalProvider';

export interface IUseNeedHelpTimingModalTriggerProps {
  catalogType: CatalogItemType;
  careerId: CareerId;
}

export const useNeedHelpTimingModalTrigger = ({ catalogType, careerId }: IUseNeedHelpTimingModalTriggerProps) => {
  const isLoggedIn = useIsLoggedIn();
  const isAnyModalOpened = useIsAnyModalOpen();
  const { data: clientVacanciesList } = vacancyApi.endpoints.getVacancyListForCurrectClient.useQuery(undefined, { skip: !isLoggedIn });
  const dispatch = useDispatch();
  const isNeedHelpShownForGuest = useSelector(needHelpShownForGuestSelector);
  const isNeedHelpShownForRegisteredUser = useSelector(needHelpShownForRegisteredUserSelector);
  const { openModal } = useModal();

  React.useEffect(() => {
    if (isLoggedIn ? isNeedHelpShownForRegisteredUser : isNeedHelpShownForGuest) {
      return;
    }

    if (!isLoggedIn && catalogType === CatalogItemType.Resume && !isAnyModalOpened && !clientVacanciesList?.length) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      const countdown = isLoggedIn ? 40000 : 2000;

      const timer = setTimeout(() => {
        if (!isAnyModalOpened) {
          openModal(NEED_HELP_TIMING_MODAL_NAME, { careerId, catalogType });
          dispatch(UXSlice.actions[isLoggedIn ? 'setNeedHelpShownForRegisteredUser' : 'setNeedHelpShownForGuest'](true));
        }
      }, countdown);

      return () => clearTimeout(timer);
    }
  }, [
    catalogType,
    careerId,
    isLoggedIn,
    isAnyModalOpened,
    openModal,
    clientVacanciesList,
    isNeedHelpShownForRegisteredUser,
    isNeedHelpShownForGuest,
    dispatch,
  ]);
};
